import React from 'react';

import ReactTimeAgo from 'react-time-ago'

/**
 * House date format for the whole admin app: en-GB, i.e. dd/MM/yyyy.
 *
 * PINNED ON PURPOSE — do not drop the argument to fall back to the browser.
 * `toLocaleDateString()` with no locale follows navigator.language, so the same
 * record read the same minute showed 9/6/2026 to an en-US operator and 6/9/2026
 * to an en-GB one. On a shared tool that is not a cosmetic difference: those are
 * two different months, and every consumer of these dates (Kanban month, P&L
 * month, Xero document date) is month-sensitive. A date nobody can read
 * unambiguously is worse than one in an unfamiliar order.
 *
 * en-GB specifically because the business runs in GBP against HMRC and Xero,
 * and because ReactTimeAgo below was ALREADY pinned to en-GB — the relative and
 * absolute renderings of the same timestamp disagreeing on locale was its own
 * small bug.
 *
 * This replaces a ~200-line navigator.language -> format-string map that was
 * computed and then thrown away: its value was never read, and
 * `toLocaleDateString()` cannot consume a "dd/MM/yyyy" pattern anyway. Deleted
 * rather than wired up, because it read as though locale handling existed here
 * when nothing of the sort was happening — and its own fallback was
 * "dd/MM/yyyy", so this is the behaviour it was reaching for.
 */
const LOCALE = 'en-GB';

const DateFormatter = ({ type, date, includeTime = false }) => {
    if (type === 'ago') {
        return <ReactTimeAgo date={date} locale={LOCALE}/>
    }

    if (!date) {
        return '-'
    }

    const parsed = new Date(date)

    let result = parsed.toLocaleDateString(LOCALE)

    if (includeTime) {
        // 2-digit, 24h. The previous `getHours() + ":" + getMinutes()` was
        // unpadded, so 09:05 rendered as "9:5".
        result += " " + parsed.toLocaleTimeString(LOCALE, {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
        })
    }

    return result
}

export default DateFormatter
